























import Vue from "vue";
import { getAnnouncements } from "@/api/Announcement";
import { AnnouncementSummary } from "@/api/dto/Announcement";
import { formatDate, sortedByDateDesc } from '@/utils/momentUtils';
import PrevNext from "@/parts/mypage/PrevNext.vue";

interface Data {
  announcements: AnnouncementSummary[];
  /**
   * 現在のページ(1-indexed)
   */
  currentPage: number,
  /**
   * お知らせの最大表示件数
   */
  announcementListSize: 15,
}

export default Vue.extend({
  components: { PrevNext },
  name: "AnnouncementsList",
  data(): Data {
    return {
      announcements: [],
      currentPage: 1,
      announcementListSize: 15,
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const res = sortedByDateDesc(await getAnnouncements(), it => it.lastUpdateAt);
      next(vm => (vm.$data as Data).announcements = res);
    } catch (e) {
      next(false);
    }
  },
  computed: {
    totalPages(): number {
      return Math.ceil(this.announcements.length / this.announcementListSize);
    },
    /**
     * 該当ページの範囲を返す
     */
    currentPageAnnouncements(): AnnouncementSummary[] {
      return this.announcements.slice((this.currentPage - 1) * this.announcementListSize, (this.currentPage) * this.announcementListSize);
    }
  },
  methods: {
    onPageChange(currentPage: number) {
      this.currentPage = currentPage;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
  },
  filters: {
    formatDate,
  },
});
